module.exports = __webpack_public_path__ + "img/9791187886440.10c6e199.jpg";